import { render } from "./MiaojiIntroduce.vue?vue&type=template&id=22f0351b&scoped=true"
import script from "./MiaojiIntroduce.vue?vue&type=script&lang=js"
export * from "./MiaojiIntroduce.vue?vue&type=script&lang=js"

import "./MiaojiIntroduce.vue?vue&type=style&index=0&id=22f0351b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f0351b"]])

export default __exports__